"use client"

import PropTypes from 'prop-types';

const MobileDropDown = ({ label, items, isOpen, onToggle }) => {
    return (
        <div className="w-full border-2 border-white rounded-lg ">
            <button
                onClick={onToggle}
                className="w-full text-left py-2 px-4 text-white "
            >
                {label}
            </button>

            {isOpen && (
                <div className="w-full grid grid-cols-1 gap-4 p-4 bg-white shadow-md transition-all duration-200 ease-in-out">
                    {(items || []).map((item, index) => (
                        <a
                            key={index}
                            href={"/"+item?.link}
                            className=" flex items-center p-2 gap-2 rounded-lg shadow-lg bg-gray-100 hover:bg-gray-200 py-10"
                        >
                            {item?.icon}
                            <div className='pr-[24px]'>
                                <h3 className="text-lg over font-semibold text-gray-800">{item.title.replace(/\u00A0/g, " ")}</h3>
                                {item?.description && (
                                    <p className="text-sm text-gray-600">{item.description}</p>
                                )}
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

MobileDropDown.propTypes = {
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            icon: PropTypes.node,
            title: PropTypes.string.isRequired,
            description: PropTypes.string
        })
    ),
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired
};

export default MobileDropDown;
